<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-name">
                TEST
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <form id="benefitForm">
                    <div class="row">
                        <!--View Update Uploads Section-->
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <img src="https://hr-portal-bucket-20181226.s3.us-west-2.amazonaws.com/1545824399-wellness-slide-1.jpg" alt="S3 Image Test"/>
                        </div>
                    </div>
                </form>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    var self;
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    export default {
        name: 'TEST',
        components: {
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
            }
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
        },
        methods: {
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/policiesandforms/test.vue